import React from 'react';
import styles from './SectionHero.module.css';

export default function SectionHero({ eyebrow, title, highlight, description }) {
  return (
    <header className={styles.hero}>
      <div className={styles.inner}>
        <span className={styles.eyebrow}>{eyebrow}</span>
        <h1 className={styles.title}>{title}<span>{highlight}</span></h1>
        <p className={styles.description}>{description}</p>
      </div>
    </header>
  );
}
